import axios from "axios";

// const baseURL = process.env.VUE_APP_API_BASE_URL || window.location.origin;
// const baseURL = "https://havaianas-confi.mbsi.com.ph";
// const baseURL = "https://localhost:5001";
// const baseURL = "https://evaair.mbsi.com.ph";
// const baseURL = "https://terrysa.mbsi.com.ph";
// const baseURL = "https://upc.mbsi.com.ph";
// const baseURL = "https://havaianas-config.mbsi.com.ph";
// const baseURL = "https://segci.mbsi.com.ph";
// const baseURL = "https://dev1.mbsi.com.ph";
// const baseURL = "https://dev-test.mbsi.com.ph";
// const baseURL = "https://autodesk.mbsi.com.ph";
const baseURL = "https://nmcps.mbsi.com.ph";

export default axios.create({
  baseURL,
L: baseURL,
  // You can add your headers here
});
